import axios from 'axios'
import * as Cookies from 'js-cookie'
import store from "@/store";
import router from "@/router";


export default {
    state: {
        token: null,
        user: {},
        guestUser: {},
        guestData: {},
        isLoading: false,
        isValidSession: {},
        isSuccess: "",
        error: {},
        isAuthModalActive: false,
        authStatus: false
    },

    getters: {
        token(state) {
            return state.token
        },
        user(state) {
            return state.user
        },
        isLoading(state) {
            return state.isLoading
        },
        isSuccess(state) {
            return state.isSuccess
        },
        error(state) {
            return state.error
        },
        guestUser(state) {
            return state.guestUser
        },
        guestData(state) {
            return state.guestData
        },
        isValidSession(state) {
            return state.isValidSession
        },
        isAuthModalActive: state => state.isAuthModalActive,
        authStatus: state => state.authStatus
    },

    actions: {
        async login({ state, commit }, data) {
            const response = await axios.post('login', data)
            const token = response.data.data.token
            const user = response.data.data.user
            const details = response.data.data.personal_details
            const isSynced = response.data.data.is_synced
            
            Cookies.set('token', token, { expires: 30 });
            localStorage.setItem('user', JSON.stringify(user))
            localStorage.setItem('details', JSON.stringify(details))
            localStorage.setItem('is_synced', isSynced)
            commit('setLogin', token, user)
            commit('setAuthStatus', true)
        },

        async logout({ commit }, statusCode) {
            statusCode ? '' : await axios.post('logout', {})

            Cookies.remove('token')

            localStorage.removeItem('user')
            localStorage.removeItem('details')
            localStorage.removeItem('isSidebarOpen')
            localStorage.removeItem('isCompleteSignup')
            localStorage.removeItem('is_synced')
            store.commit('setTutorialNotifier', false)
            store.commit("setIsLoading", false)
            commit('setAuthStatus', false)

            delete axios.defaults.headers.common['Authorization']
            commit('setLogout')
            router.push({ name: 'Login'})
        },

        async resetPassword({ commit }, data) {
            try {
                const res = await axios.post('forgot-password', data)
                store.commit("setIsSuccess", res && res.data && res.data.message);
                const newData = res && res.data && res.data.data
                commit('setResetPassword', newData)
            } catch(err) {
                store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
                throw err;
            }
        },

        async verifyPasswordToken({ commit }, data) {
            const res = await axios.get(`password/find/${data}`)
            const newData = res && res.data && res.data.data
            commit('setVerifyPasswordToken', newData)
        },

        async changePassword({ commit }, data) {
            const res = await axios.post('reset-password', data)
            store.commit("setIsSuccess", res && res.data && res.data.message);
            const newData = res && res.data && res.data.data
            commit('setChangePassword', newData)
        },

        async getCallback({ commit }, payload) {
            const res = await axios.post(`callback`, payload)
            const token = res && res.data && res.data.data && res.data.data.token
            const user = res && res.data && res.data.data && res.data.data.user
            const details = res && res.data && res.data.data && res.data.data.personal_details

            Cookies.set('token', token, { expires: 30 });
            localStorage.setItem('user', JSON.stringify(user))
            localStorage.setItem('details', JSON.stringify(details))

            commit('setCallback', token, user)
            if (user && user.initial_update == 0) {
                var url = window.location.href;
                url = url.replace(/^.*\/\/[^\/]+/, '')
                localStorage.setItem('PreviousRoute', url);
                localStorage.removeItem('PreviousRoute');
                router.push({ name: 'Register', query: { step: 4 } })
            }
        },

        async guestNativeLogin({ commit }, data) {
            const res = await axios.post('register/guest', data)
            const guestData = res && res.data
            const token = res && res.data && res.data.data && res.data.data.token
            const user = res && res.data && res.data.data && res.data.data.user

            Cookies.set('token', token, { expires: 30 });
            localStorage.setItem('user', JSON.stringify(user))

            if (user && user.user_type == 0) {
                localStorage.setItem('isGuest', 1)
            }
            commit('setGuestLogin', guestData, token, user)
        },

        async validateSession({ commit }, batchId) {
            const res = await axios.get(`session/${batchId}/validate`)
            let isValid = res && res.data;
            commit('setIsValidSession', isValid)
        }
    },

    mutations: {
        setLogin(state, token, user) {
            state.token = token, state.user = user
        },
        setLogout(state) {
            state.token = null, state.user = {}
        },
        setResetPassword(state, data) {
            state.resetPassword = data
        },
        setVerifyPasswordToken(state, data) {
            state.verifyPasswordToken = data
        },
        setChangePassword(state, data) {
            state.changePassword = data
        },
        setIsLoading(state, data) {
            state.isLoading = data
        },
        setIsSuccess(state, data) {
            state.isSuccess = data
        },
        setError(state, data) {
            state.error = data
        },
        setCallback(state, token, user) {
            state.token = token, state.user = user
        },
        setGuestLogin(state, data, token, user) {
            state.guestData = data, state.token = token, state.guestUser = user
        },
        setIsValidSession(state, data) {
            state.isValidSession = data;
        },
        setAuthModalActive (state, data) {
            state.isAuthModalActive = data
        },
        setAuthStatus (state, flag) {
            state.authStatus = flag
        }
    }
}